.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    font-family: var(--tempest-font-sans);
    color: var(--tempest-text);
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
}

.columns {
    display: flex;
    gap: var(--tempest-space-2);
    padding: var(--tempest-space-2);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    background-color: var(--tempest-surface);
    box-shadow: var(--tempest-shadow-lg);
    width: max-content;
    max-width: 100%;
}

.column {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    list-style: none;
    margin: 0;
    padding: 0 var(--tempest-space-1);
    max-height: 220px;
    overflow-y: auto;
    scroll-behavior: smooth;
}

.column + .column {
    border-left: 1px solid var(--tempest-border);
}

.cellWrapper {
    margin: 0;
}

.cell {
    appearance: none;
    width: 100%;
    min-width: 48px;
    padding: var(--tempest-space-2) var(--tempest-space-3);
    border: none;
    border-radius: var(--tempest-radius-md);
    background-color: transparent;
    color: var(--tempest-text);
    font-family: inherit;
    font-size: var(--tempest-text-base);
    text-align: center;
    cursor: pointer;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .cell:hover:not(:disabled) {
        background-color: var(--tempest-surface-2);
    }
}

.cell:focus-visible {
    outline: none;
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.cell.active {
    background-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
    font-weight: var(--tempest-weight-semibold);
}

.cell:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
}

.wrapper.disabled {
    opacity: 0.7;
}
